module.exports = __webpack_public_path__ + "img/closedPark.9fb3989f.png";